import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";

class ItemPage7 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    
    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }
    render() { 
        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Cukkini Amazon kísérlet"
                    />
                    <meta name="description" content="Cukkini Amazon kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <h2>Cukkini Amazon kísérlet</h2>
                    <div>
                        <br/>A kísérlet témája az Amazon mikrobiológiai készítmény hatásának vizsgálata a cukkini fejlődésére, immunrendszerére és termésmennyiségére.
                        <br/>Az Amazonban levő bacillus mojavensis a növények immunrendszerének stimulálásával és légköri nitrogén megkötésével fejti ki hatását. Ebben a kísérletben ezt figyeljük meg, biokertekben, cukkinin.
                        <br/>
                        <b>A kísérlet lényege, hogy nyomon követjük a növények fejlődését, termésadatokkal és fotókkal dokumentáljuk, kiértékeljük és megosztjuk.</b>
                    </div>
                    <h3>Szakmai feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az „on-garden” kísérletben 1 db 100 g-os Amazont és 6-6 db azonos fajtájú cukkini vetőmagot adunk a résztvevőknek.
                        <br/>A vetőmagokat szabadföldi ágyásba kell elvetni, fészekbe, két párhuzamos sorba. 
                        <br/>Ez azt jelenti, hogy egy ásónyomnyi talajt kiveszünk a jó minőségű, biokerti talajból, a gödör aljába érett komposztot és komposztált szerves trágyát teszünk (egy marékkal), visszahúzzuk a földet és a felső 2 cm-be belenyomunk 2 db magot. Így lesz összesen 3-3 fészek. Mindegyikből kitörjük a gyengébb növényt 4 lombleveles állapotban, tehát végül 3-3 tő kerül a kísérletbe
                        <br/>A talaj nem tartalmazhat műtrágyát, a területen az elmúlt 2 évben nem lehetett kémiai növényvédelem. 
                        <br/>A vetés tervezett ideje május 14.
                        A sorokat kérjük kis táblával megjelölni A és B betűvel.
                        <br/>A soroknak egymástól legalább 2 méterre kell lenniük, hogy ne legyen átszóródás a kezelt és a kontroll csoport között.
                        <br/>Az A sor növényeit 10 naponta le kell permetezni Amazonnal 20g/10 liter víz dózisban.
                        <br/>A növényeket a kísérlet során szerves tápanyagokkal kell ellátni és biológiai növényvédelemmel kell védeni a kártevők ellen. Ez bármilyen ökológiai gazdálkodásban engedélyezett készítmény, vagy megoldás lehet, a lényeg, hogy minden növény egységesen kapja ugyanazt a kezelést.
                        <br/>Semmilyen kémiai növényvédőszer, műtrágya, biológiai gombák elleni, vagy immunerősítő anyag nem használható a kísérlet során.
                        <br/>A kísérlet akkor minősül sikeresnek, ha legalább az egyik sorban 2 növény értékelhető termést ad.
                        <br/>A kísérlet meghiúsulása esetén nem küldünk a leírásban szereplő ajándékot.
                    </div>
                    <h3>Dokumentációs feltételek:</h3>
                    <div style={{marginTop:30}}>
                        <b>1. fotó, 2025.05.14-én: Vetéskor</b>
                        <ul>
                            <li>Az A sor középső részét felülről (a piktogram szerint), úgy, hogy az A jelzőtábla is látható legyen a képen. </li>
                            <li>A B sor középső részét felülről (a piktogram szerint), úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>2. fotó, 2025.05.28-án: Keléskor</b>
                        <br/>Vetéstől számított 14. napon kérünk a kikelő növényekről: 
                        <ul>
                            <li>Az A sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az A jelzőtábla is látható legyen a képen. </li>
                            <li>A B sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>3. fotó, 2025.06.11-én: 6 lombleveles állapot</b>
                        <br/>Az előzőtől számított kettő hét múlva ugyanabban a szögben és távolságról kérünk a növényekről felülnézetben fotót, 
                        <ul>
                            <li>Az A sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az A jelzőtábla is látható legyen a képen.</li>
                            <li>A B sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>4. fotó: 2025. 06.25-én: Virágzás állapot</b>
                        <br/>Az előzőtől számított kettő hét múlva ugyanabban a szögben és távolságról kérünk a növényekről felülnézetben fotót, 
                        <ul>
                            <li>Az A sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az A jelzőtábla is látható legyen a képen.</li>
                            <li>A B sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>5. fotó: 2025. 07.09-én: Terméshozás állapot</b>
                        <br/>Az előzőtől számított kettő hét múlva ugyanabban a szögben és távolságról kérünk a növényekről felülnézetben fotót,  
                        <ul>
                            <li>Az A sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az A jelzőtábla is látható legyen a képen.</li>
                            <li>A B sorból az egyik választott növényt (mindig ugyanazt a kísérlet folyamán), felülről, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>A fotó küldéssel egyidőben kérjük megküldeni a következő adatokat: 
                        <br/>termés mennyiség a kísérlet eddigi szakasza alatt
                        <ul>
                            <li>A sor növényeiről, db, kg</li>
                            <li>B sor növényeiről, db, kg</li>
                        </ul>
                        </b>
                        <br/>
                        <b>6. fotó: 2025. 07.23-án: Terméshozás állapot</b>
                        <br/>Az előzőtől számított kettő hét múlva ugyanabban a szögben és távolságról kérünk a növényekről felülről fotót, 
                        <ul>
                            <li>Az A sor középső szakaszáról, mely 2-3 növényt tartalmaz oldalnézetben, úgy, hogy az A jelzőtábla is látható legyen a képen.</li>
                            <li>A B sor középső szakaszáról, mely 2-3 növényt tartalmaz oldalnézetben, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>A fotó küldéssel egyidőben kérjük megküldeni a következő adatokat:  
                        <br/>termés mennyiség az előző adatközlés óta
                        <ul>
                            <li>A sor növényeiről, db, kg</li>
                            <li>B sor növényeiről, db, kg</li>
                        </ul>
                        </b>
                        <br/>
                        <b>7. fotó: 2025. 08.06-én: Terméshozás állapot</b>
                        <br/>Az előzőtől számított kettő hét múlva ugyanabban a szögben és távolságról kérünk a növényekről felülről fotót, 
                        <ul>
                            <li>Az A sor középső szakaszáról, mely 2-3 növényt tartalmaz oldalnézetben, úgy, hogy az A jelzőtábla is látható legyen a képen.</li>
                            <li>A B sor középső szakaszáról, mely 2-3 növényt tartalmaz oldalnézetben, úgy, hogy az B jelzőtábla is látható legyen a képen.</li>
                        </ul>
                        <br/>
                        <b>A fotó küldéssel egyidőben kérjük megküldeni a következő adatokat:   
                        <br/>termés mennyiség az előző adatközlés óta
                        <ul>
                            <li>A sor növényeiről, db, kg</li>
                            <li>B sor növényeiről, db, kg</li>
                        </ul>
                        </b>
                        <br/>A fotókat minden második héten csütörtök reggel 8-ig kérjük emailben megküldeni a <a className='kwizda3-link' href='mailto:marketing@muchmore.hu'>marketing@muchmore.hu</a> email címre.
                        <br/><br/>
                        <div style={{marginTop:30}}>
                            <img alt="cimke" style={{display:'inline-block', width:'25%'}} src="img/kwizda3_cimkek/nezzuk_kiserletek2_thumbnail_cukkini.jpg"></img>
                            <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src="img/kwizda3_fotoseged/web_cukkini_both.jpg"></img>
                        </div>
                    </div>
                    <h3>Nevezési feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Regisztráció a nezzukbioban.hu oldalon
                        <br/><b>Itt meg kell adni az elérhetőséget és a kísérlet helyét.</b>
                        <br/><b>Kérünk fotót az ágyások helyéről és közvetlen környezetéről.</b>
                        <br/>A jelentkezők közül 6 kertészt választunk ki. A döntésnél a termesztési hely rendezettségét, biotermesztésre alkalmasságát vizsgáljuk meg.
                        <br/>
                        <br/><b>A kiválasztott kertészeket emailben értesítjük.</b>
                        <br/>
                        <br/><b>Garantált nyeremény egy sikeresen dokumentált kísérlet után:</b>
                        <ul>
                            <li>Egy csomag 100 g-os Tyra</li>
                            <li>Székely Gyöngyvér online biológiai növényvédelmi tanfolyama</li>
                        </ul>
                        <br/>A kísérlet akkor értékelhető sikeresnek, ha mindkét sorban (A és B) legalább 2 tő elfogadható termést ad, beazonosíthatók a sorok, minden héten megkapjuk a kért minőségű fotókat, valamint a terméseredményt a kísérlet lezárásakor.
                        <br/>Ebben az esetben az ajándékokat a kísérlet befejeződése utáni két héten belül postán küldjük meg a résztvevőknek a regisztráció során megadott címre.
                        <br/>
                        <br/><b>Tartson velünk! </b>
                        <br/><b>Nézzük együtt milyen hatása van az Amazonnak a cukkínire!</b>
                    </div>
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2025. 05. 10.</td>
                                        <td>2025 05-07 között</td>
                                        <td>Szabadföldi veteményes</td>
                                        <td>Maximum 6 helyszínen</td>
                                        <td>Fotó és adatok küldése emailcímre</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(8)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage7);